import { render, staticRenderFns } from "./RadioImageButton.vue?vue&type=template&id=2fb47d25&scoped=true&"
import script from "./RadioImageButton.vue?vue&type=script&lang=ts&"
export * from "./RadioImageButton.vue?vue&type=script&lang=ts&"
import style0 from "./RadioImageButton.vue?vue&type=style&index=0&id=2fb47d25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb47d25",
  null
  
)

export default component.exports